import { Droppable } from '@hello-pangea/dnd';
import React from 'react';
import styled from 'styled-components';
import TaskCard from './TaskCard';
import { useTheme } from '@mui/material';

const Column = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
`;

const ColumnHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ theme, columnId }) => 
    columnId === 'backlog' ? theme.palette.warning.light : 
    columnId === 'inProgress' ? theme.palette.info.light : 
    theme.palette.success.light};
`;

const ColumnTitle = styled.h3`
  color: ${({ theme }) => theme.palette.getContrastText(theme.palette.background.paper)};
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TaskCount = styled.span`
  background: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.text.primary};
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const TaskListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TaskList = ({ tasks, columnId, title, onEdit, onRemove }) => {
  const theme = useTheme();
  
  return (
    <Droppable droppableId={columnId}>
      {(provided) => (
        <Column 
          {...provided.droppableProps} 
          ref={provided.innerRef}
          theme={theme}
        >
          <ColumnHeader theme={theme} columnId={columnId}>
            <ColumnTitle theme={theme}>{title}</ColumnTitle>
            <TaskCount theme={theme}>{tasks.length}</TaskCount>
          </ColumnHeader>
          <TaskListContainer>
            {tasks.map((task, index) => (
              <TaskCard 
                key={task.id} 
                task={task} 
                index={index} 
                onEdit={onEdit}
                onRemove={onRemove}
              />
            ))}
            {provided.placeholder}
          </TaskListContainer>
        </Column>
      )}
    </Droppable>
  );
};

export default TaskList;